export default "__VITE_ASSET__dbfbe4fa__"